import { TailSpin } from  'react-loader-spinner'
import { Container } from "reactstrap";

export function Loading(){
    return(
        <Container className="d-flex justify-content-center align-item-center pt-5">
            <TailSpin
                height="80"
                width="80"
                color="#0A66C2"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}    
            />


        </Container>
            
    )
}